export default "__VITE_ASSET__790adc65__"